import * as React from 'react';
import Slider from '@material-ui/core/Slider/Slider';
import './ReviewSlider.css';
import { MARK_LABELS } from '../../../../utils';

interface Props {
	value: number;
	onChange: (value: number) => void;
}

const ReviewSlider: React.FC<Props> = ({ value, onChange }) => {
	return (
		<div className="reviewSlider">
			<div className="reviewSlider-markArea">
				<div className="reviewSlider-markArea__mark">{value}</div>

				<div className="reviewSlider-markArea__desc">
					{MARK_LABELS[value - 1]}
				</div>
			</div>

			<Slider
				min={1}
				max={10}
				defaultValue={value}
				marks={true}
				step={1}
				onChange={(e, value) => onChange(value as number)}
				classes={{
					root: "review-slider",
				}}
			/>
		</div>
	);
};

export default ReviewSlider;
